import { render, staticRenderFns } from "./updateProject.vue?vue&type=template&id=4353c868&scoped=true"
import script from "./updateProject.vue?vue&type=script&lang=js"
export * from "./updateProject.vue?vue&type=script&lang=js"
import style0 from "./updateProject.vue?vue&type=style&index=0&id=4353c868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4353c868",
  null
  
)

export default component.exports